import { ChevronDown } from 'lucide-react';
import { User as UserIcone } from "lucide-react";
import { LogOut } from "lucide-react";
import React from "react";
import "./bandeau_user.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { User } from "../../../types/user";
import { Menu } from "@mantine/core";
import { Link } from "react-router-dom";

export function Bandeau_user() {
  const user = useSelector<RootState, User>((state) => state.user);

  const dispatch = useDispatch();

  return (
    <div className={"bandeau_user"}>
      Bonjour,
      <Menu position="bottom-end">
        <Menu.Target>
          <button className={"sec"}>
            <UserIcone /> {user.nom_affichage} <ChevronDown />
          </button>
        </Menu.Target>

        <Menu.Dropdown>
          {/*<Menu.Label>Application</Menu.Label>*/}
          <Menu.Item leftSection={<UserIcone />}>
            <Link to="/mon-compte">Mon compte</Link>
          </Menu.Item>
          <Menu.Item color="red" leftSection={<LogOut />}>
            <Link to="/logout">Déconnexion</Link>
          </Menu.Item>

          {/*<Menu.Divider />*/}

          {/*<Menu.Label>Danger zone</Menu.Label>*/}
          {/*<Menu.Item icon={<Icone nom={"gear"} />}>Transfer my data</Menu.Item>*/}
        </Menu.Dropdown>
      </Menu>
    </div>
  );
}
